import { render, staticRenderFns } from "./woodStock.vue?vue&type=template&id=81dca208&"
import script from "./woodStock.vue?vue&type=script&lang=js&"
export * from "./woodStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports